export const numberFormatter = Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 2,
});
